import { MINUTE } from '@/core/constants/constants'

import { createApiMethod, type } from './utils/createApiMethod'

export const USER_CONSENTS = [
  'general_news',
  'content_updates',
  'platform_updates',
  'personal_recommendations',
  'system_notifications',
] as const

export type Consent = (typeof USER_CONSENTS)[number]

export interface ConsentSchema {
  enabled_notifications: Consent[]
}

export const authUser = {
  consents: {
    list: createApiMethod({
      method: 'GET',
      path: '/auth/user/consents',
      response: type<ConsentSchema>(),
    }),

    update: createApiMethod({
      method: 'PUT',
      path: '/auth/user/consents',
      data: type<ConsentSchema>(),
    }),

    listByKey: createApiMethod({
      method: 'GET',
      path: '/auth/user/consents/:consentKey',
      response: type<ConsentSchema>(),
    }),

    updateByKey: createApiMethod({
      method: 'PUT',
      path: '/auth/user/consents/:consentKey',
      data: type<ConsentSchema>(),
    }),
  },
}

export const authUserQueries = {
  all: () => ['auth-user'] as const,
  consentsList: () => ({
    queryKey: [...authUserQueries.all(), 'consents-list'] as const,
    queryFn: () => authUser.consents.list(),
    staleTime: 5 * MINUTE,
  }),
  consentsListByKey: (consentKey: string) => ({
    queryKey: [
      ...authUserQueries.all(),
      'consents-list-by-key',
      consentKey,
    ] as const,
    queryFn: () => authUser.consents.listByKey({ params: { consentKey } }),
    staleTime: 5 * MINUTE,
  }),
}
